"use client";
import React, { useEffect, useState } from "react";
import { BiChevronRight } from "react-icons/bi";
import { Button } from "@mui/base/Button";
import { useFormik } from "formik";
import { contactValidationSchema } from "../form/validationSchema";
import { contactInitalValues } from "../form/initalValues";
import { CircularProgress } from "@mui/material";
import TextInput from "../form/TextInput";
import { Contact } from "@/lib/http";
import { useRouter } from "next/navigation";

const BlogForm = ({
  title = true,
  product,
}: {
  title?: boolean;
  product?: string | number;
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useRouter();
  const [currentPage, setCurrentPage] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentPage(window.location.href);
    }
  }, []);

  const formInuput = [
    {
      type: "text",
      name: "Name",
      label: "Name",
      isRequired: true,
      size: "half",
    },
    {
      type: "email",
      name: "EmailID",
      label: "Email",
      isRequired: true,

      size: "half",
    },
    {
      type: "number",
      name: "PhoneNo",
      label: "Phone",
      isRequired: true,
      size: "half",
    },
    {
      type: "text",
      name: "Location",
      label: "Location",
      isRequired: true,
      size: "half",
    },
    {
      type: "text",
      multiline: true,
      rows: 4,
      name: "Message",
      label: "Message",
      size: "full",
    },
  ];

  const onSubmit = async (values: Record<string, any>) => {
    setLoading(true);
    try {
      const res = await Contact.api("post", {
        data: {
          ...values,
          Type: "Enquiry",
          ProductID: product || 0,
          SourceUrl:currentPage
        },
      });
      if (res?.status === 200)
        if (res.data.status === "success") navigate.push("/thank-you");
    } catch (error) {
      console.log(error);
    }
    resetForm();
    setLoading(false);
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleSubmit,
    handleChange,
    resetForm,
  } = useFormik({
    initialValues: contactInitalValues,
    validationSchema: contactValidationSchema,
    onSubmit,
  });

  return (
    <div
      className="p-8 rounded-xl  
     relative lg:basis-[40%] basis-full"
    >
      {title ? (
        <>
          {" "}
          <h3 className="text-2xl font-bold text-secondary-dark ">
            Request a Quote
          </h3>
          <p className="mt-1 mb-5 text-sm font-medium text-secondary-main">
            {" "}
            Elevate your quality assurance process to new heights
          </p>
        </>
      ) : null}
      <form onSubmit={handleSubmit}>
        <div className="md:grid grid-cols-1 gap-3">
          {formInuput?.map((f, i) => {
            const { size, name, ...rest } = f;
            return (
              <div key={name} className={size === "full" ? "" : ""}>
                <TextInput
                  size="small"
                  {...rest}
                  name={name}
                  value={values[name] || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched[name] && Boolean(errors[name])}
                  helperText={(touched[name] && errors[name]) || ""}
                />
              </div>
            );
          })}
        </div>

        <Button
          disabled={loading}
          className=" group mt-5 overflow-y-hidden  bg-primary-main  py-2 px-6 hover:border hover:border-primary-main font-semibold rounded-full flex items-center relative  before:absolute before:bottom-0 before:left-0 before:bg-white before:translate-y-12 hover:before:translate-y-0 before:transition-all before:w-full before:h-full before:rounded-full"
          type="submit"
        >
          <p className="relative flex items-center group-hover:text-primary-main text-white">
            Submit{" "}
            {loading ? (
              <CircularProgress size={10} className="text-white mx-2" />
            ) : (
              <BiChevronRight className="text-xl" />
            )}
          </p>
        </Button>
      </form>
    </div>
  );
};

export default BlogForm;
